package br.com.htms.inspeccaocampo.data

import br.com.htms.inspeccaocampo.platform.randomUuid

data class CampoConfig(
    val id: String = "campo_${randomUuid()}",
    val titulo: String,
    val ativo: Boolean = true,
    val obrigatorio: Boolean = true,
    val fotoObrigatoriaSeSim: Boolean = true,
    val fotoObrigatoriaSeNao: Boolean = true
)

data class AppConfig(
    val nomeApp: String = "HTMS ENERGIA",
    val nomeInspecao: String = "Portal QSSMA",
    val bannerPath: String? = null,
    /** Campos da Inspeção de Campo Diária. */
    val campos: List<CampoConfig> = camposPadrao(),
    /** Itens da Parte 2 (Checklist) do Relatório Alojamento. */
    val camposAlojamentoChecklist: List<CampoConfig> = camposAlojamentoChecklistPadrao(),
    /** Itens da Parte 1 (Relatório fotográfico) do Relatório Alojamento. */
    val camposAlojamentoFoto: List<CampoConfig> = camposAlojamentoFotoPadrao(),
    /** Campos da Comunicação de ocorrências (visibilidade / rótulo). */
    val camposOcorrencias: List<CampoConfig> = camposOcorrenciasPadrao()
) {
    fun camposAtivos(): List<CampoConfig> = campos.filter { it.ativo }

    fun camposAlojamentoChecklistAtivos(): List<CampoConfig> =
        camposAlojamentoChecklist.filter { it.ativo }

    fun camposAlojamentoFotoAtivos(): List<CampoConfig> =
        camposAlojamentoFoto.filter { it.ativo }

    fun campoOcorrencia(id: String): CampoConfig? =
        camposOcorrencias.find { it.id == id }

    fun ocorrenciaAtiva(id: String): Boolean =
        campoOcorrencia(id)?.ativo != false

    fun rotuloOcorrencia(id: String, padrao: String): String =
        campoOcorrencia(id)?.titulo?.takeIf { it.isNotBlank() } ?: padrao

    companion object {
        fun camposPadrao(): List<CampoConfig> = listOf(
            CampoConfig(id = "item_1", titulo = "APR assinada?", fotoObrigatoriaSeNao = false),
            CampoConfig(id = "item_2", titulo = "PT emitida (quando aplicável)?", fotoObrigatoriaSeNao = false),
            CampoConfig(id = "item_3", titulo = "EPIs adequados para executar a atividade?"),
            CampoConfig(id = "item_4", titulo = "Ferramentas inspecionadas?", fotoObrigatoriaSeNao = false),
            CampoConfig(id = "item_5", titulo = "Equipamentos em conformidade?"),
            CampoConfig(id = "item_6", titulo = "Área sinalizada e isolada?"),
            CampoConfig(id = "item_7", titulo = "Área organizada e limpa?"),
            CampoConfig(id = "item_8", titulo = "Aterramento instalado e em conformidade?")
        )

        fun camposAlojamentoChecklistPadrao(): List<CampoConfig> =
            ChecklistAlojamentoCatalog.itensBase().map { item ->
                CampoConfig(
                    id = item.id,
                    titulo = item.titulo,
                    ativo = true,
                    obrigatorio = item.obrigatorio,
                    fotoObrigatoriaSeSim = item.fotoObrigatoria,
                    fotoObrigatoriaSeNao = false
                )
            }

        fun camposAlojamentoFotoPadrao(): List<CampoConfig> =
            RelatorioFotoCatalog.itensBase().map { item ->
                CampoConfig(
                    id = item.id,
                    titulo = item.titulo,
                    ativo = true,
                    obrigatorio = item.obrigatorio,
                    fotoObrigatoriaSeSim = item.fotoObrigatoria,
                    fotoObrigatoriaSeNao = false
                )
            }

        fun camposOcorrenciasPadrao(): List<CampoConfig> = listOf(
            CampoConfig(id = "cliente", titulo = "Cliente", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "obra", titulo = "Nome da obra", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "caracterizacao", titulo = "Caracterização", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "tipo", titulo = "Tipo", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "dataHoraOcorrido", titulo = "Data/hora do ocorrido", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "localExato", titulo = "Local exato", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "quemReportando", titulo = "Quem está reportando", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "tipoEvento", titulo = "Classe do evento", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "envolvido", titulo = "Envolvido (nome/função)", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "responsavel", titulo = "Responsável pela atividade", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "dadosAcidente", titulo = "Dados do acidente", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "acoesTomadasImediato", titulo = "Ações tomadas no imediato", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "descricaoEvento", titulo = "Descrição do evento", fotoObrigatoriaSeSim = false, fotoObrigatoriaSeNao = false),
            CampoConfig(id = "fotos", titulo = "Fotos da ocorrência", fotoObrigatoriaSeSim = true, fotoObrigatoriaSeNao = false)
        )

        fun padrao(): AppConfig = AppConfig()
    }
}
